export default __webpack_public_path__ + "static/media/1.563e3418.svg";